export enum EPermissionKeys {
    // Purchase orders
    PO_ADD = 'PO_ADD',
    PO_EDIT = 'PO_EDIT',
    PO_VIEW = 'PO_VIEW',
    PO_DELETE = 'PO_DELETE',
    // User
    USER_ADD = 'USER_ADD',
    USER_EDIT = 'USER_EDIT',
    USER_VIEW = 'USER_VIEW',
    USER_DELETE = 'USER_DELETE',
    // Cost Center
    COSTCENTER_ADD = 'COSTCENTER_ADD',
    COSTCENTER_EDIT = 'COSTCENTER_EDIT',
    COSTCENTER_DELETE = 'COSTCENTER_DELETE',
    COSTCENTER_VIEW = 'COSTCENTER_VIEW',
    // Cribs
    CRIB_DELETE = 'CRIB_DELETE',
    CRIB_EDIT = 'CRIB_EDIT',
    CRIB_VIEW = 'CRIB_VIEW',
    // Org
    ORG_VIEW = 'ORG_VIEW',
    ORG_EDIT = 'ORG_EDIT',
    // Bin
    BIN_VIEW = 'BIN_VIEW',
    BIN_ADD = 'BIN_ADD',
    BIN_EDIT = 'BIN_EDIT',
    BIN_DELETE = 'BIN_DELETE',
    // Item
    ITEM_VIEW = 'ITEM_VIEW',
    ITEM_ADD = 'ITEM_ADD',
    ITEM_DELETE = 'ITEM_DELETE',
    ITEM_EDIT = 'ITEM_EDIT',
    // Fire
    FIREINCIDENT_VIEW = 'FIREINCIDENT_VIEW',
    FIREINCIDENT_ADD = 'FIREINCIDENT_ADD',
    FIREINCIDENT_DELETE = 'FIREINCIDENT_DELETE',
    FIREINCIDENT_EDIT = 'FIREINCIDENT_EDIT',
    // Supplier
    SUPPLIER_ADD = 'SUPPLIER_ADD',
    SUPPLIER_VIEW = 'SUPPLIER_VIEW',
    SUPPLIER_EDIT = 'SUPPLIER_EDIT',
    SUPPLIER_DELETE = 'SUPPLIER_DELETE',
    // Restriction
    RESTRICTION_VIEW = 'RESTRICTION_VIEW',
    RESTRICTION_EDIT = 'RESTRICTION_EDIT',
    RESTRICTION_ADD = 'RESTRICTION_ADD',
    RESTRICTION_DELETE = 'RESTRICTION_DELETE',
    // Item Restrictions
    ITEMLIMIT_VIEW = 'ITEMLIMIT_VIEW',
    ITEMLIMIT_EDIT = 'ITEMLIMIT_EDIT',
    ITEMLIMIT_DELETE = 'ITEMLIMIT_DELETE',
    ITEMLIMIT_ADD = 'ITEMLIMIT_ADD',
    // Usergroup
    USERGROUP_VIEW = 'USERGROUP_VIEW',
    USERGROUP_EDIT = 'USERGROUP_EDIT',
    USERGROUP_DELETE = 'USERGROUP_DELETE',
    // Crib group
    CRIBGROUP_VIEW = 'CRIBGROUP_VIEW',
    CRIBGROUP_EDIT = 'CRIBGROUP_EDIT',
    CRIBGROUP_DELETE = 'CRIBGROUP_DELETE',
    // Replenishments
    ORDERDETAIL_ADD = 'ORDERDETAIL_ADD',
    ORDERDETAIL_EDIT = 'ORDERDETAIL_EDIT',
    ORDERDETAIL_DELETE = 'ORDERDETAIL_DELETE',
    ORDERDETAIL_VIEW = 'ORDERDETAIL_VIEW',
    // Scheduling
    SCHEDULE_ADD = 'JOB_ADD',
    SCHEDULE_EDIT = 'JOB_EDIT',
    SCHEDULE_VIEW = 'JOB_VIEW',
    SCHEDULE_DELETE = 'JOB_DELETE',
    // Customer
    CUSTOMER_VIEW = 'CUSTOMER_VIEW',
    CUSTOMER_ADD = 'CUSTOMER_ADD',
    CUSTOMER_EDIT = 'CUSTOMER_EDIT',
    CUSTOMER_DELETE = 'CUSTOMER_DELETE',
    // Notifications
    NOTIFICATION_VIEW = 'NOTIFICATION_VIEW',
    // Transactions
    TRANSACTIONLOG_VIEW = 'TRANSACTIONLOG_VIEW',
    // Roles & Permissions
    ROLE_VIEW = 'ROLE_VIEW',
    // Reports
    REPORT_VIEW = 'REPORT_VIEW',
    // Locations
  LOCATION_VIEW = 'LOCATION_VIEW',
  LOCATION_ADD= 'LOCATION_ADD',
  LOCATION_EDIT= 'LOCATION_EDIT',
  LOCATION_DELETE= 'LOCATION_DELETE',
  // Invoices
  INVOICE_ADD = 'INVOICE_ADD',
  INVOICE_EDIT = 'INVOICE_EDIT',
  INVOICE_DELETE = 'INVOICE_DELETE',
    INVOICE_VIEW = 'INVOICE_VIEW',
  WORKCATEGORY_ADD = 'WORKCATEGORY_ADD',
  WORKCATEGORY_EDIT = 'WORKCATEGORY_EDIT',
  WORKCATEGORY_DELETE = 'WORKCATEGORY_DELETE',
  WORKCATEGORY_VIEW = 'WORKCATEGORY_VIEW',
    // Patient
    PATIENT_ADD = 'PATIENT_ADD',
    PATIENT_EDIT = 'PATIENT_EDIT',
    PATIENT_DELETE = 'PATIENT_DELETE',
    PATIENT_VIEW = 'PATIENT_VIEW',
    // Insurance
    INSURANCE_ADD = 'INSURANCE_ADD',
    INSURANCE_EDIT = 'INSURANCE_EDIT',
    INSURANCE_DELETE = 'INSURANCE_DELETE',
    INSURANCE_VIEW = 'INSURANCE_VIEW',
    // Doctor
    DOCTOR_ADD = 'DOCTOR_ADD',
    DOCTOR_EDIT = 'DOCTOR_EDIT',
    DOCTOR_DELETE = 'DOCTOR_DELETE',
    DOCTOR_VIEW = 'DOCTOR_VIEW',
    // Employer
    EMPLOYER_ADD = 'EMPLOYER_ADD',
    EMPLOYER_EDIT = 'EMPLOYER_EDIT',
    EMPLOYER_DELETE = 'EMPLOYER_DELETE',
    EMPLOYER_VIEW = 'EMPLOYER_VIEW',
    // FEESCHEDULE
    FEESCHEDULE_ADD = 'FEESCHEDULE_ADD',
    FEESCHEDULE_EDIT = 'FEESCHEDULE_EDIT',
    FEESCHEDULE_DELETE = 'FEESCHEDULE_DELETE',
    FEESCHEDULE_VIEW = 'FEESCHEDULE_VIEW',

    // General Ledger Account
    GENERALLEDGERACCOUNT_ADD = 'GENERALLEDGERACCOUNT_ADD',
    GENERALLEDGERACCOUNT_EDIT = 'GENERALLEDGERACCOUNT_EDIT',
    GENERALLEDGERACCOUNT_DELETE = 'GENERALLEDGERACCOUNT_DELETE',
    GENERALLEDGERACCOUNT_VIEW = 'GENERALLEDGERACCOUNT_VIEW',

    // Payment Code
    PAYMENTCODE_ADD = 'PAYMENTCODE_ADD',
    PAYMENTCODE_EDIT = 'PAYMENTCODE_EDIT',
    PAYMENTCODE_DELETE = 'PAYMENTCODE_DELETE',
    PAYMENTCODE_VIEW = 'PAYMENTCODE_VIEW',

  // CHARGE Code
  CHARGECODE_ADD = 'CHARGECODE_ADD',
  CHARGECODE_EDIT = 'CHARGECODE_EDIT',
  CHARGECODE_DELETE = 'CHARGECODE_DELETE',
  CHARGECODE_VIEW = 'CHARGECODE_VIEW',


  // COMPLAINT Code
  COMPLAINT_ADD = 'COMPLAINT_ADD',
  COMPLAINT_EDIT = 'COMPLAINT_EDIT',
  COMPLAINT_DELETE = 'COMPLAINT_DELETE',
  COMPLAINT_VIEW = 'COMPLAINT_VIEW',

  SETTING_VIEW = 'SETTING_VIEW',
  APISUBSCRIPTION_VIEW = 'APISUBSCRIPTION_VIEW',
  IMPORT_VIEW = 'IMPORT_VIEW',
}
